export const EXPORTS_SIDEBAR_ITEM_TEST_ID = 'exports-side-bar-item';
export const EXPORTED_PAYOUTS_SIDEBAR_ITEM_TEST_ID =
  'exported-payouts-side-bar-item';
export const EXPORTED_PAYINS_SIDEBAR_ITEM_TEST_ID =
  'exports_sidebar_pay-ins-link';
export const EXPORTED_STATEMENTS_SIDEBAR_ITEM_TEST_ID =
  'exported-statements-side-bar-item';
export const PAYOUT_REQUESTS_SIDEBAR_ITEM_TEST_ID =
  'payout-requests-side-bar-item';
export const ACCOUNTS_SIDEBAR_ITEM_TEST_ID = 'accounts';
export const ACCOUNTS_FUNDING_SIDEBAR_TEST_ID = 'accounts-funding';
export const ACCOUNTS_FUNDING_MODAL_ACCOUNT_SELECTOR_TEST_ID =
  'accounts-funding-modal-account-selector';
export const CRYPTO_FUNDING_SIDEBAR_ITEM_TEST_ID = 'crypto_funding';
export const PAYOUTS_SIDEBAR_ITEM_TEST_ID = 'payouts';
export const BATCHES_SIDEBAR_ITEM_TEST_ID = 'batches';
export const PAYOUT_DRAFTS_PENDING_SIDEBAR_ITEM_TEST_ID =
  'payout-drafts-pending-side-bar-item';
export const RECEIVERS_SIDEBAR_ITEM_TEST_ID = 'receivers';
export const USER_MANAGEMENT_SIDEBAR_ITEM_TEST_ID = 'user-management';
export const COLLECTION_SIDEBAR_ITEM_TEST_ID = 'collections';
export const ORDERS_SIDEBAR_ITEM_TEST_ID = 'orders';
export const ACCOUNT_WITHDRAWALS_ITEM_TEST_ID = 'withdrawals';
export const DEVELOPERS_SIDEBAR_ITEM_TEST_ID = 'developers';
export const AUTHENTICATION_SIDEBAR_ITEM_TEST_ID =
  'developers-authentication-side-bar-item';
export const WEBHOOKS_SIDEBAR_ITEM_TEST_ID =
  'developers-webhooks-side-bar-item';
export const MCP_SIDEBAR_ITEM_TEST_ID = 'developers-mcp-side-bar-item';
export const CONFIGURATIONS_SIDEBAR_ITEM_TEST_ID = 'configurations';
export const BUSINESS_UNITS_SIDEBAR_ITEM_TEST_ID =
  'configurations-business-units-side-bar-item';
export const PROFILE_SIDEBAR_ITEM_TEST_ID = 'settings-profile';

// Component IDs
export const CRYPTO_FUNDING_SIDEBAR_COMPONENT_ID =
  'crypto_funding_sidebar_item';

export const SIDEBAR_TOGGLE_TEST_ID = 'sidebar-toggle';
